import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ae1e605"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "content-summary-preview bg-white rounded-1 shadow p-2"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "labels" }
const _hoisted_7 = {
  class: "d-flex align-items-center flex-wrap",
  style: {"min-height":"100%"}
}
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_10 = ["data-dp-tooltip"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      class: "name position-relative",
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShowPreview(true))),
      onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setShowPreview(false)))
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.template.name), 1),
      (_ctx.hasContentSummary)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              innerHTML: _ctx.template.notification_template.content_summary
            }, null, 8, _hoisted_3)
          ], 512)), [
            [_vShow, _ctx.isShowPreview]
          ])
        : _createCommentVNode("", true)
    ], 32),
    _createElementVNode("td", {
      class: "name",
      onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setShowPreview(true))),
      onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShowPreview(false)))
    }, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.template.notification_template.subject), 1)
    ], 32),
    _createElementVNode("td", {
      class: "season",
      onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowPreview(true))),
      onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setShowPreview(false)))
    }, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.template.season?.description || '-'), 1)
    ], 32),
    _createElementVNode("td", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.template.labels || []), (label, idx) => {
          return (_openBlock(), _createElementBlock("span", {
            key: idx,
            class: "badge bg-primary me-1"
          }, _toDisplayString(label), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("td", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update', _ctx.template))),
          class: "btn btn-icon btn-primary ms-2",
          "data-dp-tooltip": _ctx.$t('edit'),
          "data-dp-position": "left"
        }, _hoisted_12, 8, _hoisted_10)
      ])
    ])
  ]))
}